
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Login from "../pages/auth/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import Members from "../pages/members/Members";
import AdminLayout from "../components/layout/AdminLayout";
import MembershipPlans from "../pages/membership-plans/MembershipPlans";
import Payments from "../pages/payments/Payments";
import Staffs from "../pages/staffs/Staffs";
import AssignRoles from "../pages/assign-roles/AssignRoles";
import Masters from "../pages/masters/Masters";
import Settings from "../pages/settings/Settings";
import Reports from "../pages/reports/Reports";
import AddressDownloadPlans from "../pages/address-plans/AddressDownloadPlans";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route element={<AdminLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/members" element={<Members />} />
        <Route path="/membership-plans" element={<MembershipPlans />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/staffs" element={<Staffs />} />
        <Route path="/assign-roles" element={<AssignRoles />} />
        <Route path="/masters" element={<Masters />} />
        <Route path="settings" element={<Settings />} />
        <Route path="reports" element={<Reports />} />
        <Route path="/address-download-plans" element={<AddressDownloadPlans />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRoutes;
